// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { requiredStringMustBeGreaterThanOrEqualZero } from 'validators/common'

export const validateFrequency = (k, v) => {
  const r = {
    loFrequency: +v[k] > +v.hiFrequency && 'Must be <= High Frequency.',
    hiFrequency: +v[k] < +v.loFrequency && 'Must be >= Low Frequency.',
  }
  return requiredStringMustBeGreaterThanOrEqualZero(v[k]) || r[k]
}
